import { render, staticRenderFns } from "./RevenueKpis.vue?vue&type=template&id=75dc86f2&scoped=true&"
import script from "./RevenueKpis.vue?vue&type=script&lang=js&"
export * from "./RevenueKpis.vue?vue&type=script&lang=js&"
import style0 from "./RevenueKpis.vue?vue&type=style&index=0&id=75dc86f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dc86f2",
  null
  
)

export default component.exports